import * as React from 'react';
import { useHistory } from 'react-router-dom';
// # components
import { AdminScene } from '../';
import { PlanList } from './';
// # services
import { route } from '@/services';

/**
 * Renders the plans admin panel page content.
 */
const PlansSceneLayout: React.SFC = () => {
    const history = useHistory();

    /**
     * Redirects to the new plans route.
     * (Currently this opens a modal.)
     *
     * @returns {void}
     */
    const handleNewPlanRedirect = (): void => {
        history.push(route('admin.plans.new').make());
    };

    return (
        <AdminScene title="Plans">
            <div className="flex mar-bt-20">
                <div className="flex flex-justify-flex-end">
                    <a
                        onClick={handleNewPlanRedirect}
                        className="btn-c2a style-new-item"
                    >
                        <i className="text-icon">+</i>
                        New Plan
                    </a>
                </div>
            </div>

            <div className="content-container">
                <PlanList />
            </div>
        </AdminScene>
    );
};

export default PlansSceneLayout;

